import { c as _c } from "react/compiler-runtime";
import { MAILING_SETTINGS_SENDER_EMAILS_API } from 'modules/profile/mailing-settings/api/mailing-settings-sender-emails-api';
import { SenderEmailsAddressesApiInterface } from 'modules/profile/mailing-settings/types/sender-email-address-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { SwrPaginationInterface } from 'shared/types/pagination-interface';
import useSWR from 'swr';
export function useSenderEmailAddresses(t0) {
  const $ = _c(9);
  const {
    pagination,
    limit
  } = t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  let t2;
  if ($[1] !== limit || $[2] !== pagination || $[3] !== user) {
    t2 = () => {
      if (!limit || !user) {
        return;
      }
      if (pagination.startFromId === undefined) {
        return `${MAILING_SETTINGS_SENDER_EMAILS_API}/list?pagination[limit]=${limit}`;
      } else {
        if (pagination.startFromId) {
          return `${MAILING_SETTINGS_SENDER_EMAILS_API}/list?pagination[startFrom]=${pagination.startFromId}&pagination[order]=${pagination.order}&pagination[limit]=${limit}`;
        }
      }
      return null;
    };
    $[1] = limit;
    $[2] = pagination;
    $[3] = user;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    data: emailAddresses,
    isValidating,
    mutate
  } = useSWR(t2, fetcher);
  let t3;
  if ($[5] !== emailAddresses || $[6] !== isValidating || $[7] !== mutate) {
    t3 = {
      emailAddresses,
      isValidating,
      mutate
    };
    $[5] = emailAddresses;
    $[6] = isValidating;
    $[7] = mutate;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}